import { AppStyled } from "./AppStyled";
import Sign from "./components/Sign/Sign.js";
import Header from "./components/Header/Header.js";
import Explanation from "./components/Explanation/Explanation";

function App() {
  return (
    <AppStyled>
        <Header />
      <AppStyled.ContentContainer>
        <Sign />
        <Explanation />
      </AppStyled.ContentContainer>
    </AppStyled>
  );
}

export default App;
